import { ThemeModule } from '../../front/lib/ThemeModule';
import { createApp } from 'vue';
import SiteHeaderApp from './SiteHeaderApp.vue';
const THRESHOLD_SCROLL_UP = -100;
const THRESHOLD_SCROLL_DOWN = 100;
const WAIT_FOR_SCROLL_MS = 500;
export class SiteHeader extends ThemeModule {
    constructor() {
        super(...arguments);
        this.appEl = this.getElementById('app');
        this.app = createApp(SiteHeaderApp, { siteHeader: this });
        this.appInstance = this.app.mount(this.appEl);
    }
    init() {
        this.initAutoDuck();
    }
    afterInit() {
    }
    makeId(id) {
        return this.id + '-' + id;
    }
    /**
     * Hides header automatically when user scrolls up.
     *
     * This implementation allows for some leeway when scrolling both ways to avoid excessive toggling.
     * Note that distance is reset after some time to begin tracking new delta value
     */
    initAutoDuck() {
        let distanceDelta = 0;
        let prevScrollY = window.scrollY;
        let resetter = null;
        const reset = () => {
            distanceDelta = 0;
            prevScrollY = window.scrollY;
            if (resetter) {
                window.clearTimeout(resetter);
            }
            if (window.scrollY < this.root.offsetHeight) {
                removeHiddenState();
            }
        };
        const removeHiddenState = () => {
            this.root.classList.remove('is--hidden');
            document.body.style.removeProperty('--site-content-top-offset');
        };
        const setHiddenState = () => {
            this.root.classList.add('is--hidden');
            document.body.style.setProperty('--site-content-top-offset', 'var(--s-wp-adminBar-height)');
        };
        window.addEventListener('scroll', event => {
            var _a;
            if (!((_a = this.appInstance) === null || _a === void 0 ? void 0 : _a.canDuck())) {
                removeHiddenState();
                return;
            }
            distanceDelta = Math.max(THRESHOLD_SCROLL_UP, Math.min(THRESHOLD_SCROLL_DOWN, distanceDelta + (window.scrollY - prevScrollY)));
            prevScrollY = window.scrollY;
            if (distanceDelta <= THRESHOLD_SCROLL_UP) {
                removeHiddenState();
            }
            else if (distanceDelta >= THRESHOLD_SCROLL_DOWN) {
                setHiddenState();
            }
            if (resetter) {
                window.clearTimeout(resetter);
            }
            resetter = window.setTimeout(reset, WAIT_FOR_SCROLL_MS);
        }, { passive: true });
    }
}
